
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md',
  type = 'button',
  className = '',
  onClick,
  ...props 
}: ButtonProps) {
  const baseClasses = 'font-semibold whitespace-nowrap cursor-pointer transition-all duration-300 ease-in-out inline-flex items-center justify-center';
  
  const variantClasses = {
    primary: 'bg-[#4F301F] text-white hover:bg-[#3d2518] border-0',
    secondary: 'bg-amber-600 text-white hover:bg-amber-700 border-0',
    outline: 'border-2 border-[#4F301F] text-[#4F301F] bg-transparent hover:bg-[#4F301F] hover:text-white'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm rounded-md',
    md: 'px-6 py-3 text-base rounded-lg',
    lg: 'px-8 py-4 text-lg rounded-xl'
  };
  
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
